import { find, remove } from "lodash";
import $ from "jquery";

export function handleDragStart(e) {
  e.dataTransfer.setData("text", e.target.id);
  e.dataTransfer.setData(
    "question-id",
    e.target.getAttribute("data-question-id")
  );
  e.dataTransfer.setData(
    "possible_answer_id",
    e.target.getAttribute("data-possible-answer-id")
  );
  e.dataTransfer.setData(
    "data_exercise_id",
    e.target.getAttribute("exercise_id")
  );
  e.dataTransfer.setData(
    "data_section_id",
    e.target.getAttribute("section_id")
  );
  e.dataTransfer.setData(
    "data_page_id",
    e.target.getAttribute("page_id")
  );
  e.dataTransfer.setData(
    "answer_possible_type",
    e.target.getAttribute("data_possible_type")
  );
}

export function handleDragEnterLeave(e) {
  if (e.type === "dragenter") {
  } else {
  }
}
export const handleOverDrop = (answers , IsCrossMatch = false) => (e) => {
  let dataAttribute = e.target.getAttribute("data-box");
  let possible_question_number = parseInt(
    e.target.getAttribute("data-possible-answer-number")
  );
  let exercise_id = parseInt(
    e.target.getAttribute("exercise_id")
  );
  let section_id = parseInt(
    e.target.getAttribute("section_id")
  );
  let page_id = parseInt(
    e.target.getAttribute("page_id")
  );
  let data_answer_type =(
    e.target.getAttribute("data_possible_type")
  );

  let possible_answer_id = parseInt(
    e.dataTransfer.getData("possible_answer_id")
  );
  let target_question_id = parseInt(e.target.getAttribute("data-question-id"));
  let dropped_question_id = parseInt(e.dataTransfer.getData("question-id"));
  e.preventDefault();
  if (target_question_id === dropped_question_id && e.target.getAttribute("data-reset-answer")) {
    var draggedId1 = e.dataTransfer.getData("text");
    var draggedEl1 = document.getElementById(draggedId1);
    let data_answer_possible_type =(
      e.dataTransfer.getData("answer_possible_type")
    );
    let exercise_id_data = parseInt(
      e.dataTransfer.getData("data_exercise_id")
    );
    let section_id_data = parseInt(
      e.dataTransfer.getData("data_section_id")
    );
    let page_id_data = parseInt(
      e.dataTransfer.getData("data_page_id")
    );
    if (data_answer_possible_type == "Exercise")
    {
      ResetAnswer(
        answers,
        target_question_id,
        possible_question_number,
        possible_answer_id
      );
    }
    else if (data_answer_possible_type == "Assessment"){
      AssessmentResetAnswer(
        answers,
        possible_question_number,
        possible_answer_id,
        target_question_id,
        page_id_data,
        section_id_data,
        exercise_id_data
      );
    }
    if (IsCrossMatch) {
      $(`#${target_question_id}${possible_answer_id}`).removeClass("d-inline")
    }
    
  
    


  if (draggedEl1) {
    if (draggedEl1.parentNode === e.target) {
      return;
    }
    draggedEl1.parentNode.removeChild(draggedEl1);
    e.target.appendChild(draggedEl1);
    
  }
  return true;
    
  }

  if (dataAttribute !== null || target_question_id !== dropped_question_id) {
    return;
  }

  if (
    e.type !== "drop" ||
    (e.target.children.length > 0 && e.target.id !== "parentBox")
  ) {
    return;
  }

  var draggedId = e.dataTransfer.getData("text");
  var draggedEl = document.getElementById(draggedId);

  if (draggedEl) {
    if (draggedEl.parentNode === e.target) {
      return;
    }
    draggedEl.parentNode.removeChild(draggedEl);
    e.target.appendChild(draggedEl);
    $(`#emptydiv${target_question_id}${possible_answer_id}`).remove()
    if (data_answer_type == "Exercise")
    {
      manageAnswers(
        answers,
        target_question_id,
        possible_question_number,
        possible_answer_id
      );
    }
    else{
      payloadmakerfordraganddrop(
        answers,
        possible_question_number,
        possible_answer_id,
        possible_question_number,
        target_question_id,
        page_id,
        section_id,
        exercise_id
      );
    }
  
  }
  return true;
};

const manageAnswers = (
  answers,
  question_id,
  possible_question_number,
  possible_answer_id
) => {
  let found_answer = find(answers, ["question_id", question_id]);
  if (found_answer) {
    let found_possibile_answer = find(found_answer.selected_answers, [
      "id",
      possible_answer_id,
    ]);
    if (found_possibile_answer) {
      let answer_index = found_answer.selected_answers.indexOf(found_possibile_answer);
      remove(
        found_answer.selected_answers,
        (answer_item_id) =>
        found_answer.selected_answers.indexOf(answer_item_id) === answer_index 
      );
     
    }
    found_answer.selected_answers.push({
      number: possible_question_number,
      id: possible_answer_id,
    });
  } else {
      answers.push({
        question_id: question_id,
        selected_answers: [
          { number: possible_question_number, id: possible_answer_id },
        ],
      });
  }
  
};

const payloadmakerfordraganddrop = (
  answers,
  possible_question_number,
  possible_answer_id,
  question_number,
  question_id,
  page_id,
  section_id,
  exercise_id
)=> {
  let not_found_in_array = true;
  if (answers.length === 0) {
    answers.push({
      section_id: section_id,
      page_id: page_id,
      exercise_id: exercise_id,
      answers: [
        {
          question_id,
          selected_answers: [
            { number: possible_question_number, id: possible_answer_id },
          ],
        },
      ],
    });
  } else {
    answers &&
      answers.forEach((answer) => {
        if (
          answer.section_id === section_id &&
          answer.exercise_id === exercise_id &&
          answer.page_id === page_id
        ) {
          not_found_in_array = false;
          let found_answer = find(answer.answers, ["question_id", question_id]);
          if (found_answer) {
            let found_selected_answer = find(found_answer.selected_answers, [
              "number",
              question_number,
            ]);
            if (found_selected_answer) {
              found_selected_answer["id"] = possible_answer_id;
                let answer_index = found_answer.selected_answers.indexOf(found_selected_answer);
                remove(
                  found_answer.selected_answers,
                  (answer_item_id) =>
                  found_answer.selected_answers.indexOf(answer_item_id) === answer_index 
                );
            } else {
              found_answer.selected_answers.push({
                number: question_number,
                id: possible_answer_id,
              });
            }
          } else {
            answer.answers.push({
              question_id,
              selected_answers: [
                { number: question_number, id: possible_answer_id },
              ],
            });
          }
        }
      });
    if (not_found_in_array) {
      answers.push({
        section_id: section_id,
        page_id: page_id,
        exercise_id: exercise_id,
        answers: [
          {
            question_id,
            selected_answers: [
              { number: possible_question_number, id: possible_answer_id },
            ],
          },
        ],
      });
    }
  }
};
const ResetAnswer = (
  answers,
  question_id,
  possible_question_number,
  possible_answer_id
) => {
  let found_answer = find(answers, ["question_id", question_id]);
  if (found_answer) {
    let found_possibile_answer = find(found_answer.selected_answers, [
      "id",
      possible_answer_id,
    ]);
    if (found_possibile_answer) {
      let answer_index = found_answer.selected_answers.indexOf(found_possibile_answer);
      remove(
        found_answer.selected_answers,
        (answer_item_id) =>
        found_answer.selected_answers.indexOf(answer_item_id) === answer_index 
      );
     
    }
  } 
  
};
const AssessmentResetAnswer = (
  answers,
  possible_question_number,
  possible_answer_id,
  question_id,
  page_id,
  section_id,
  exercise_id
) => {
  answers &&
  answers.forEach((answer) => {
    if (
      answer.section_id === section_id &&
      answer.exercise_id === exercise_id &&
      answer.page_id === page_id
    ) {
      let found_answer = find(answer.answers, ["question_id", question_id]);
      if (found_answer) {
        let found_selected_answer = find(found_answer.selected_answers, [
          "id",
          possible_answer_id,
        ]);
        if (found_selected_answer) {
          found_selected_answer["id"] = possible_answer_id;
            let answer_index = found_answer.selected_answers.indexOf(found_selected_answer);
            remove(
              found_answer.selected_answers,
              (answer_item_id) =>
              found_answer.selected_answers.indexOf(answer_item_id) === answer_index 
            );
        } 
      }
    }
  });
  // let found_answer = find(answers, ["question_id", question_id]);
  // if (found_answer) {
  //   let found_possibile_answer = find(found_answer.selected_answers, [
  //     "id",
  //     possible_answer_id,
  //   ]);
  //   if (found_possibile_answer) {
  //     let answer_index = found_answer.selected_answers.indexOf(found_possibile_answer);
  //     remove(
  //       found_answer.selected_answers,
  //       (answer_item_id) =>
  //       found_answer.selected_answers.indexOf(answer_item_id) === answer_index 
  //     );
     
  //   }
  // } 
  
};